import { CSSProperties, FC } from 'react';

import { Ad, Statistic } from '@/__generated_graphql__/graphql';
import { AdsList } from '@/components/AdsList/AdsList';
import { RightArrowIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { ColTypes, NoAdsVariantEnum } from '@/constants/common';
import { useNavigate } from '@/hooks/useNavigate';
import { transformAdsToCards } from '@/utils/helpers/transformAdsToCard';

import { AdStatisticBar } from './AdStatisticBar';
import * as S from './Dashboard.styles';

type Props = {
  path?: string;
  title: string;
  ads: Ad[];
  loading: boolean;
  statistic?: Statistic;
  titleStyles?: CSSProperties;
  isLast?: boolean;
  isLoadingMore?: boolean;
  length?: ColTypes;
};

export const AdSection: FC<Props> = ({
  path,
  title,
  ads,
  loading,
  statistic,
  titleStyles,
  isLast = false,
  isLoadingMore,
  length
}) => {
  const { navigate } = useNavigate();

  const cards = transformAdsToCards(ads);

  const handleClickTitle = () =>
    !!path &&
    navigate({
      route: path,
      params: {
        sortBy: 'DATE'
      }
    });

  return (
    <S.Section $isLast={isLast}>
      <S.SectionHeader>
        <S.TitleWrapper style={titleStyles}>
          <Typography onClick={handleClickTitle} variant="h4" htmlTag="h2">
            {title}
          </Typography>
          {!!path && <RightArrowIcon />}
        </S.TitleWrapper>
        {statistic && <AdStatisticBar statistic={statistic} />}
      </S.SectionHeader>
      <AdsList
        cards={cards}
        loading={loading}
        noDataVariant={NoAdsVariantEnum.NONE}
        isLoadingMore={isLoadingMore}
        length={length}
      />
    </S.Section>
  );
};
